import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import CourseRating from "../../models/course-rating.model";
import Enrollment from "../../models/enrollment.model";
import { CourseRatingService } from "../../services/course-rating.service";
import { NotificationService } from "../../services/notifications.service";
import { StudentService } from "../../services/student.service";

@Component({
  selector: "ngx-dialog-receive-gift",
  templateUrl: "dialog-receive-gift.component.html",
  styleUrls: ["dialog-receive-gift.component.scss"],
})
export class DialogReceiveGiftComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() enrol: Enrollment = new Enrollment();

  stars: number = 10;

  rating: CourseRating = new CourseRating();
  ratingId: string = "";
  title: string = "";
  description: string = "";
  ratingSelects = [1, 2, 3, 4, 5];
  ratingSelected: number = 4;
  ratingForm: FormGroup;
  loading = false;
  submitted = false;
  showGift = false;

  imageURL = "/assets/images/giftbox.gif";

  constructor(
    protected ref: NbDialogRef<DialogReceiveGiftComponent>,
    private fb: FormBuilder,
    private studentService: StudentService,
    private ratingService: CourseRatingService,
    private notiService: NotificationService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.ratingForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
    });

    this.getMyRatings();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;
    this.loading = true;

    if (
      this.ratingSelected != this.rating.rating ||
      this.title != this.rating.title ||
      this.description != this.rating.description
    ) {
      this.sendRating();
    }

    this.studentService
      .receivedGift(this.enrol.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.stars = data.stars;
          this.enrol.receivedGift = true;

          //Send notification to tutor
          this.notiService.create(
            "Nhận",
            `/enrollments`,
            this.enrol.id,
            this.enrol.courseId,
            `${this.stars}* hoàn thành khóa học`,
            `${this.enrol.course.title}`,
            this.enrol.course.createdBy,
            `/tutor/courses/${this.enrol.courseId}`,
            this.enrol.courseId
          );
        }

        this.showGift = true;
        this.loading = false;
      });
  }

  getMyRatings(): void {
    this.loading = true;
    this.ratingService
      .getCurrentRatings(this.enrol.courseId, this.enrol.createdBy)
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          const doc = querySnapshot.docs[querySnapshot.docs.length - 1];
          this.ratingId = doc.id;
          this.rating = doc.data();
          this.ratingSelected = this.rating.rating;
          this.title = this.rating.title;
          this.description = this.rating.description;
        }

        this.loading = false;
      });
  }

  sendRating() {
    this.loading = true;
    this.submitted = true;

    const newRating = new CourseRating();
    newRating.courseId = this.enrol.courseId;
    newRating.rating = this.ratingSelected;
    newRating.title = this.title;
    newRating.description = this.description;
    newRating.refTitle = this.enrol.course.title;
    newRating.toUid = this.enrol.course.createdBy;

    this.ratingService
      .createRating(newRating)
      .then((result) => {
        newRating.id = result;
        this.loading = false;
        this.submitted = false;
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });

    if (this.ratingId != "") {
      this.ratingService
        .deleteRating(this.enrol.courseId, this.ratingId)
        .then((result) => {});
    }
  }
}
